// extracted by mini-css-extract-plugin
export default {"container":"Home_container__OOJgn","alimatha":"Home_alimatha__QBTKG","bigLogo":"Home_bigLogo__nU5dc","body":"Home_body__9+-oL","embarkText":"Home_embarkText__QUj7E"};